import request from '@/utils/request';

export function authen(data) {
  // console.log(JSON.stringify(data));
  return request({
    url: '/auth/twitter/redirect',
    method: 'get',
    params: data,
  });
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  });
}

export function csrf() {
  return request({
    url: '/sanctum/csrf-cookie',
    method: 'get',
  });
}

export function callback(data) {
  // console.log(JSON.stringify(data));
  return request({
    url: '/auth/twitter/callback',
    method: 'get',
    params: data,
  });
}

export function afterCallback(data) {
  // console.log(JSON.stringify(data));
  return request({
    url: '/authen',
    method: 'post',
    data: data,
  });
}